import Phaser from 'phaser'
import GameUtil from '../utils/game-util'

export default class AlertPoints {
  /** @type Phaser.GameObjects.Sprite */
  AlertPoints = null

  /**
   * @type {{
   * context: Phaser.Scene,
   * }}
   **/
  sceneContext = {}

  /**
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    this.sceneContext = context
  }

  preload() {}

  create() {}

  hideAlert() {
    if (this.AlertPoints === null) return

    this.sceneContext.tweens.add(
      {
        targets: this.AlertPoints,
        alpha: 0,
        duration: 500,
        ease: 'Power2',
        onComplete: () => {
          this.AlertPoints.destroy()
          this.AlertPoints = null
        },
      },
      this.sceneContext
    )
  }

  showAlert(poinst) {
    this.AlertPoints !== null && this.AlertPoints.destroy()

    let alertPosition = GameUtil.getViewPercentage(
      { X: 50, Y: 50 },
      this.sceneContext.plataforma
    )

    this.AlertPoints = this.sceneContext.add
      .image(alertPosition.X, alertPosition.Y, `alert${poinst}Points`)
      .setOrigin(0.5)
      .setAlpha(0)
      .setDepth(2)

    this.sceneContext.tweens.add(
      {
        targets: this.AlertPoints,
        alpha: 1,
        duration: 1000,
        ease: 'Power2',
        onComplete: () => {
          this.sceneContext.time.addEvent({
            delay: 1000,
            callback: () => this.hideAlert(),
          })
        },
      },
      this.sceneContext
    )
  }
}
